import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next"; 
import { Container, Navbar, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom"; 
import LanguageSelector from "./LanguageSelector";
import LoginMenu from "./LoginMenu"; 
import "./NavMenu.css";

class NavMenu extends Component {

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        
        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        try {
            // Call server to see if user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const data = await res.json();
                this.setState({ userIsAuthenticated: data.isAuthenticated });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking user authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    doLogin() {
        // Redirect to MVC login page
        window.location.href = "/Account/Login";
    }

    doLogout() {
        // Call logout endpoint on server
        fetch("/Account/Logout", { method: "POST", credentials: "include" })
            .then(() => window.location.href = "/") // redirect after logout
            .catch(err => console.error("Logout failed:", err));
    }

    render() {
        const t = this.props.t;
        const isAuthenticated = this.props.userIsAuthenticated;
        return (
            <header className="ShipsRadioHeader">  
                <Navbar className="navbar-expand-md border-bottom box-shadow mb-3" dark style={{ backgroundColor: "#004D44"}}>
                    <Container>
                        <div className="HarpImage mx-1" > </div>
                        <NavbarBrand tag={Link} to="/">{t("Common.NavMenuTitle")}</NavbarBrand>
                        <LanguageSelector />
                        <LoginMenu userIsAuthenticated={isAuthenticated} t={t} />
                    </Container>  
                </Navbar>  
            </header >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userIsAuthenticated: state.currentUserInfo.isAuthenticated || false
    };
};


const languageAwareComponent = withTranslation()(NavMenu);

export default connect(mapStateToProps)(languageAwareComponent);